export function isDOMElementVisible(element) {
    const bounding = element.getBoundingClientRect();
    return bounding.width > 0 && bounding.height > 0;
}
